// extracted by mini-css-extract-plugin
export default {"s-checkbox":"CustomCheckbox_s-checkbox__FnQ5b","check-label":"CustomCheckbox_check-label__MTMIX"};